import type { Methods as AvailableDeliveryPeriodMethods } from '@/api/v1/available-delivery-period'
import type { Methods as UnallocatedOrderItemsMethods } from '@/api/v1/employee/unallocated-order-items'
import type { Methods as DetailByUnshippedConditionsMethods } from '@/api/v1/order-histories/unshipped'
// import type {Methods as OrderHistoryCsvMethods} from "@/api/v1/order-histories/_downloadId/download"

export const orderHistoryKeyFactory = {
  all: [{ scope: 'orderHistory' }] as const,
  detailBySalesOrderNo: ({
    pathParams,
  }: {
    pathParams: { salesOrderNo: string }
  }) =>
    [
      {
        ...orderHistoryKeyFactory.all[0],
        entity: 'detailBySalesOrderNo',
        pathParams,
      },
    ] as const,
  detailByUnshippedConditions: ({
    queryParams,
  }: {
    queryParams: DetailByUnshippedConditionsMethods['get']['query']
  }) =>
    [
      {
        ...orderHistoryKeyFactory.all[0],
        entity: 'detailByUnshippedConditions',
        queryParams,
      },
    ] as const,
  availableDeliveryPeriod: ({
    queryParams,
  }: {
    queryParams: AvailableDeliveryPeriodMethods['get']['query']
  }) => [
    {
      ...orderHistoryKeyFactory.all[0],
      entity: 'availableDeliveryDatePeriod',
      queryParams,
    },
  ],
  orderHistoriesCsv: ({
    pathParams,
  }: {
    pathParams: { downloadId: string }
  }) => [
    {
      ...orderHistoryKeyFactory.all[0],
      entity: 'orderHistoriesCsv',
      pathParams,
    },
  ],
  unallocatedOrderItems: ({
    queryParams,
  }: {
    queryParams: UnallocatedOrderItemsMethods['get']['query']
  }) => [
    {
      ...orderHistoryKeyFactory.all[0],
      entity: 'unallocatedOrderItems',
      queryParams,
    },
  ],
}
